import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@kizen/kds/Button';
import { versionQaIds } from './qaIds';

export type VersionActionsProps = {
  qaPrefix: string;
  canUndo: boolean;
  canRedo: boolean;
  onUndo: () => void;
  onRedo: () => void;
};

export const VersionActions: FC<VersionActionsProps> = ({
  qaPrefix,
  canUndo,
  canRedo,
  onUndo,
  onRedo,
}) => {
  const { t } = useTranslation();
  const qa = versionQaIds(qaPrefix);
  return (
    <>
      <Button
        variant="text"
        color="tertiary"
        leftIcon="text-undo"
        leftIconSettings={{
          size: 'sm',
          tooltipTitleOverride: '',
          tooltipDescriptionOverride: t('Undo'),
          tooltipPosition: 'top',
        }}
        onClick={onUndo}
        disabled={!canUndo}
        qa={{ id: qa.undo }}
      />
      <Button
        variant="text"
        color="tertiary"
        leftIcon="text-redo"
        leftIconSettings={{
          size: 'sm',
          tooltipTitleOverride: '',
          tooltipDescriptionOverride: t('Redo'),
          tooltipPosition: 'top',
        }}
        onClick={onRedo}
        disabled={!canRedo}
        qa={{ id: qa.redo }}
      />
    </>
  );
};
